import GET from './api/get'

export default {
  GET,
}
